import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Film, Tv, Menu, X } from "lucide-react"; // icons
import "./header.scss";
import logo from "./../../assets/logo.png";
import * as Config from "./../../constants/Config";

const headerNav = [
  {
    display: "Home",
    path: `/${Config.HOME_PAGE}`,
    icon: <Home size={20} />,
  },
  {
    display: "Movies",
    path: `/${Config.HOME_PAGE}/movie`,
    icon: <Film size={20} />,
  },
  {
    display: "TV Series",
    path: `/${Config.HOME_PAGE}/tv`,
    icon: <Tv size={20} />,
  },
];

const Header = () => {
  const { pathname } = useLocation();
  const headerRef = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const active = headerNav.findIndex((e) => e.path === pathname);

  useEffect(() => {
    const shrinkHeader = () => {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        headerRef.current?.classList.add("shrink");
      } else {
        headerRef.current?.classList.remove("shrink");
      }
    };

    window.addEventListener("scroll", shrinkHeader);
    return () => {
      window.removeEventListener("scroll", shrinkHeader);
    };
  }, []);

  return (
    <header ref={headerRef} className="header glassy">
      <div className="header__wrap container">
        {/* Logo */}
        <Link to={`/${Config.HOME_PAGE}`} className="logo">
          <img src={logo} alt="aMovies logo" />
          <span className="brand">aMovies</span>
        </Link>

        {/* Desktop Nav */}
        <nav className={`header__nav ${mobileOpen ? "open" : ""}`}>
          <ul>
            {headerNav.map((e, i) => (
              <li key={i} className={`${i === active ? "active" : ""}`}>
                <Link to={e.path} onClick={() => setMobileOpen(false)}>
                  <span className="nav-icon">{e.icon}</span>
                  <span className="nav-text">{e.display}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Mobile Toggle Button */}
        <button
          className="mobile-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
